"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAdAnalyticsMedia = void 0;
const AdAnalyticsPlacementTypes_1 = require("../../entity/AdAnalyticsPlacementTypes");
const createAdAnalyticsMedia = () => AdAnalyticsPlacementTypes_1.AdAnalyticsMedia.fromJSON({
    key: 'audience_network',
    name: 'hoge',
    placements: [
        AdAnalyticsPlacementTypes_1.AdAnalyticsPlacement.fromJSON({
            key: 'all_placements',
            name: '',
        }),
    ],
});
exports.createAdAnalyticsMedia = createAdAnalyticsMedia;
